import React from 'react';
import PropTypes from 'prop-types';

import { Button, Modal } from '../lumen';

export default function ConfirmationDialog({
  cancelText = 'Cancel',
  confirmText = 'Ok',
  autoFocusConfirm = true,
  showing,
  children,
  onConfirm,
  onCancel,
  trackingItemConfirm,
  trackingItemCancel
}) {
  return (
    <Modal
      open={showing}
      onClose={onCancel}
      footer={
        <>
          {onCancel && (
            <Button onClick={onCancel} data-tracking-item={trackingItemCancel}>
              {cancelText}
            </Button>
          )}
          <Button
            variant="dark"
            autoFocus={autoFocusConfirm}
            onClick={onConfirm}
            data-tracking-item={trackingItemConfirm}
          >
            {confirmText}
          </Button>
        </>
      }
    >
      <div className="confirmation-dialog__question">{children}</div>
    </Modal>
  );
}

ConfirmationDialog.propTypes = {
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
  showing: PropTypes.bool.isRequired,
  autoFocusConfirm: PropTypes.bool,
  trackingItemCancel: PropTypes.string,
  trackingItemConfirm: PropTypes.string
};
